import { formatToCurrency } from "shared/utils";
import { FC } from "react";
import { cx } from "utils/classnames";

interface FeeDisplayProps {
  feeInCents?: number;
  currency?: string;
  className?: string;
  label?: string;
  labelClassName?: string;
  showSign?: boolean;
}

const FeeDisplay: FC<FeeDisplayProps> = ({
  feeInCents,
  currency,
  className,
  label,
  labelClassName,
  showSign = true
}) => {
  if (!feeInCents || !currency) return <p className={className}>--</p>;

  return (
    <p
      className={cx(
        className,
        feeInCents > 0
          ? "text-success-700"
          : feeInCents < 0
            ? "text-danger-600"
            : "text-content-400"
      )}
    >
      {label && <span className={labelClassName}>{label}: &nbsp;</span>}

      {formatToCurrency({
        cents: showSign ? feeInCents : Math.abs(feeInCents),
        currency
      })}
    </p>
  );
};

export default FeeDisplay;
